import { Helmet } from "react-helmet-async";

interface IGoogleTagProps {
    id: string;
}

export default function GoogleTag({ id }: IGoogleTagProps) {
    return (
        <Helmet>
            <script async src={`https://www.googletagmanager.com/gtag/js?id=${id}`} />
            <script>
                {`
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    gtag('config', '${id}');
                `}
            </script>
        </Helmet>
    );
}
